import { memo } from 'react';
import type { ReactNode } from 'react';
import withErrorBoundary from '../../../../core/components/errors/withErrorBoundary';
import { TableSpacer } from '../../../../core/components/table/TableRow';
import type { ProductBackorder } from '../../../queries/useProductBackorders';
import type { BaseProductData, ProductCustomerPrice } from '../../../types';
import ProductVariantsTableProductRow from './ProductVariantsTableProductRow';

const ProductVariantsTableProduct = ({
    hideImageColumn = false,
    fixedWidth = false,
    showAvailabilityMessage = false,
    isLast = false,
    emphasizeSku = false,
    product,
    shouldShowSiblingsColumn,
    shouldShowVariantsColumn,
    actionsColumn,
    showDiscountColumn,
    backorders,
    customerPriceLoading,
}: {
    hideImageColumn?: boolean;
    fixedWidth?: boolean;
    showAvailabilityMessage?: boolean;
    showDiscountColumn?: boolean;
    backorders?: Record<string, ProductBackorder[]>;
    isLast?: boolean;
    emphasizeSku?: boolean;
    shouldShowSiblingsColumn: boolean;
    shouldShowVariantsColumn: boolean;
    actionsColumn?(sku: string): ReactNode;
    product: BaseProductData & {
        sku?: string;
        customerPrice?: ProductCustomerPrice;
    };
    customerPriceLoading?: boolean;
}) => {
    const commonProps = {
        productId: product.id,
        variantCount: product.variants.length || 1,
        shouldShowSiblingsColumn,
        shouldShowVariantsColumn,
        siblingAttributes: product.siblingAttributes,
        showAvailabilityMessage,
        actionsColumn,
        emphasizeSku,
        fixedWidth,
        customerPriceLoading,
    };

    return (
        <>
            {product.variants.length > 0 ? (
                product.variants.map((variant, index) => (
                    <ProductVariantsTableProductRow
                        {...commonProps}
                        sku={variant.sku}
                        key={variant.sku}
                        showThumbnail={index === 0 && !hideImageColumn}
                        customerPrice={variant.customerPrice}
                        product={product}
                        variant={variant}
                        variationAttributes={variant.variationAttributes}
                        showDiscountColumn={showDiscountColumn}
                        backorders={backorders}
                    />
                ))
            ) : (
                <ProductVariantsTableProductRow
                    {...commonProps}
                    showThumbnail={!hideImageColumn}
                    sku={product.sku ?? ''}
                    customerPrice={product.customerPrice}
                    product={product}
                    shouldShowVariantsColumn={false}
                    showDiscountColumn={showDiscountColumn}
                    backorders={backorders}
                />
            )}
            {!isLast && <TableSpacer />}
        </>
    );
};

export default memo(withErrorBoundary(ProductVariantsTableProduct));
